import { Component, OnInit } from '@angular/core';
import { InternationalizationService } from 'app/shared/services/internationalization.service';

@Component({
  selector: 'app-painel-sidebar',
  templateUrl: './painel-sidebar.component.html',
  styleUrls: ['./painel-sidebar.component.scss']
})
export class PainelSidebarComponent implements OnInit {

  public menu: Object;
  public keys;

  constructor(
    private internationalizationService: InternationalizationService) {

    this.menu = {
      'painel-dashboard/dashboard': {
        title: '',
        icon: 'pie_chart',
        link: '/painel/dashboard'
      },
      'painel-dashboard/cities': {
        title: '',
        icon: 'location_on',
        link: '/painel/cities'
      },
      'painel-dashboard/suppliers': {
        title: '',
        icon: 'business',
        link: '/painel/suppliers'
      },
      "painel-dashboard/solutions": {
        title: '',
        icon: 'grid_on',
        link: '/painel/solutions'
      },
      'painel-dashboard/indicators': {
        title: '',
        icon: 'timeline',
        link: '/painel/indicators'
      },
      'painel-dashboard/diagnose-form': {
        title: '',
        icon: 'link',
        link: '/painel/generate-city-profile-link'
      },
      // 'all-updates/all-updates': {
      //   title: '',
      //   icon: 'update',
      //   link: '/painel/all-updates'
      // },
      'navigation/accounts': {
        title: '',
        icon: 'people',
        link: '/painel/accounts'
      },
      'painel-dashboard/settings': {
        title: '',
        icon: 'tune',
        link: '/painel/settings'
      },
      'painel-dashboard/update-indicators': {
        title: '',
        icon: 'upload',
        link: '/painel/update-indicators'
      }
    };

    this.keys = Object.keys(this.menu);

    this.keys.forEach(element => {
      internationalizationService.translate.get(element).subscribe((text: string) => {
        this.menu[element].title = text;
      });

    });

  }

  ngOnInit() {
  }

}
